let active: (() => void) | null = null;

/**
 * Only one voice note plays at a time, across every bubble (and every widget on the page): a player
 * that starts calls this, which pauses whichever one was playing. Returns the release to call when
 * this player stops (or unmounts); a stale release never drops a newer player.
 */
export function claimPlayback(pause: () => void): () => void {
  if (active && active !== pause) active();
  active = pause;
  return () => {
    if (active === pause) active = null;
  };
}
